import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface ISelectionButton {
    id: string;
    disabled?: boolean;
    text?: string;
    description?: string;
    iconPath?: string;
    selected?: boolean;
}

@Component({
    selector: "app-selection-button",
    templateUrl: "./selection-button.component.html",
    styleUrls: ["./selection-button.component.scss"],
})
export class SelectionButtonComponent implements OnInit {
    @Input()
    public buttonInfoBehaviorSubject: BehaviorSubject<ISelectionButton>;
    @Output() public buttonOnClick = new EventEmitter<ISelectionButton>();

    public buttonInfo: ISelectionButton;

    ngOnInit(): void {
        this.buttonInfoBehaviorSubject.subscribe((buttonInfo) => {
            this.buttonInfo = buttonInfo;
        });
    }

    public buttonSelected() {
        if (!this.buttonInfo.disabled) {
            this.buttonOnClick.emit(this.buttonInfo);
        }
    }
}
